<!-- Ticker.vue: 現在時刻のラインを表示する -->
<template lang="html">
  <div id="ticker" :style="getStyle" v-show="isEnable()">↑now</div>
</template>
<script>
import {
  mapGetters
} from 'vuex'

export default {
  data () {
    return {
      time: new Date(),
      style: {
        width: this.$store.state.columnWidth * this.$store.state.mobileWidthMagnification * 16 + this.$store.state.rulerWidth + 'px',
        height: '0px',
        left: '0px',
        top: '0px',
        'margin-left': '0px'
      },
      intID: 0
    }
  },
  computed: {
    ...mapGetters([
      'tableWidth',
      'timeToPosition'
    ]),
    getStyle () {
      return this.style
    }
  },
  methods: {
    updateStyle () {
      if (this.time.getHours() < 10 || (this.time.getHours() >= 22 && this.time.getMinutes() >= 0)) {
        this.style.top = '0px'
        clearInterval(this.intID)
      }
      let top = this.timeToPosition(this.time.getHours() + ':' + this.time.getMinutes()) +
        this.$store.state.tbHeaderHeight + this.$store.state.headerHeight
      this.style.top = top - 40 + 'px' // -40は調整...スマートに直したい
    },
    isEnable () {
      return !(this.time.getHours() < 10 || (this.time.getHours() >= 22 && this.time.getMinutes() >= 0)) &&
        (this.time.getDate() === this.$store.state.curDate.getDate() && this.time.getMonth() === this.$store.state.curDate.getMonth())
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.updateStyle()
      this.intID = setInterval(() => {
        this.time = new Date()
        this.updateStyle()
      }, 1000 * 60)
    })
  }
}
</script>

<style lang="css" scoped>
#ticker {
  text-align: left;
  position: absolute;
  border-style: solid;
  color: #ffd500;
  border-color: #ffd500;
  opacity: 0.8;
  border-width: 1px;
  height: 1px;
  overflow: visible;
  z-index: 1005;
  font-size: 5vw;
}
</style>



// WEBPACK FOOTER //
// SpTicker.vue?4c30b41d